import React, { useState, useEffect } from 'react';
import Findep from './findep'
import * as locale from '../locale'
import { restoreFromSessionStorageAfiShort, restoreFromSessionStorageSrv } from "../components/pages/afi/restoreSessionStorage"

const LayoutsComponent = ({ broker, companyName, location, layout, pageContext, render, gradient, menu, currentStep, iconos }) => {
    const lang = pageContext?.locale
    const [country, setCountry] = useState('')

    useEffect(() => {        
        async function chTheme() {
            let urlParams = new URLSearchParams(window.location.search)            
            let afiCountry = restoreFromSessionStorageAfiShort('afiStateShort')
            let srvConnect = restoreFromSessionStorageSrv('srvConnect')            

            //CODIGO PARA RECOMENDADOS.
            let prospectoId=urlParams.get('prospectoId')||'NoReceived'
            if(prospectoId ==='NoReceived'){
                console.log("no llego presolicitud de recomendados")
            }else{                
                let firstName=urlParams.get('firstName')||''
                let lastName=urlParams.get('lastName')||''
                let mobileNumber=urlParams.get('mobileNumber')||''
                let postalCode=urlParams.get('postalCode')||''
                let email=urlParams.get('email')||''                
                let recomendados={
                    prospectoId: prospectoId,
                    firstName: firstName,
                    lastName: lastName,
                    mobileNumber: mobileNumber,
                    postalCode: postalCode,
                    email:email                    
                }              
                await sessionStorage.setItem('recomendados', JSON.stringify(recomendados))  
            }
            if (srvConnect === "notFound") {setCountry(afiCountry)}            
            setCountry(JSON.parse(sessionStorage.getItem("afiStateShort")))
            
            var script = document.createElement("script");
            script.src = "https://acsbapp.com/apps/app/dist/js/app.js";
            script.async = true;
            script.onload = function(){
                acsbJS.init({
                    statementLink : '', 
                    footerHtml : '', 
                    hideMobile : false, 
                    hideTrigger : false, 
                    disableBgProcess : false, 
                    language : 'en', 
                    position : 'left', 
                    leadColor : '#505a72', 
                    triggerColor : '#505a72', 
                    triggerRadius : '50%', 
                    triggerPositionX : 'right', 
                    triggerPositionY : 'bottom', 
                    triggerIcon : 'people', 
                    triggerSize : 'medium', 
                    triggerOffsetX : 20, 
                    triggerOffsetY : 20, 
                    mobile : { 
                                triggerSize : 'small', 
                                triggerPositionX : 'right', 
                                triggerPositionY : 'center', 
                                triggerOffsetX : 10, 
                                triggerOffsetY : 0, 
                                triggerRadius : '50%' 
                            }
                });
            };
            
            document.body.appendChild(script); 
        }
         chTheme()
    }, [])
    
    return (
        <Findep country={country} broker={broker} appContext={{ locale: locale[lang] }} location={location} pageContext={pageContext} currentStep={(currentStep >= 0 && currentStep !== null) ? currentStep : null} iconos={iconos ? iconos : null} companyName={companyName} gradient={gradient ? true : false} menu={menu ? true : false}>{render()}</Findep>
    )            
    
}

export default LayoutsComponent